import { useState } from 'react';
import useProfileCommonStore from '../use-profile-common-store';
import { PROFILE_API_TYPES } from '../../../hooks/api/_constants';

import {
  useChartHistoricalReturns
} from '../../../hooks/api';

const PERIODS = [
  { label: 'Monthly', value: 'M' },
  { label: 'Quarterly', value: 'Q' }
];

const useHistoricalRatesOfReturn = ({ selectedPeriod }) => {
  const {
    apiConfigBase,
    commonState
  } = useProfileCommonStore();

  const fundName = (commonState
    && commonState.xref
    && commonState.xref.data
    && commonState.xref.data.name) ? commonState.xref.data.name : '';

  const { client, xid } = apiConfigBase;
  const apiType = PROFILE_API_TYPES.prop;

  const [period, setPeriod] = useState(selectedPeriod === 'Monthly' ? PERIODS[0] : PERIODS[1]);
  const [chartWidth, setChartWidth] = useState();

  const chartInputs = {
    apiType,
    client,
    shouldLoad: !!chartWidth, // don't make chart call until the container has a width
    params: {
      barColor: '#0053A3',
      height: 300,
      period: period.value,
      width: chartWidth >= 720 ? chartWidth : 720,
      xid
    }
  };

  const { data = {} } = useChartHistoricalReturns(chartInputs);
  const { image: chart, disclosure, redemptionFee } = data;
  let { supplementalData: chartData } = data;
  if (!(chartData && chartData.bars && chartData.bars.length)) {
    const emptyArray = (new Array(8)).fill({});
    chartData ? chartData.bars = emptyArray : chartData = { bars: emptyArray };
  }

  return {
    onChangePeriod: setPeriod,
    onResizeChart: setChartWidth,
    periods: PERIODS,
    periodSelected: period,
    chart,
    disclosure,
    chartData,
    fundName,
    redemptionFee
  };
};

export default useHistoricalRatesOfReturn;
